<template>
  <div class="d-flex justify-content-between">
    <h1>Vorlagen</h1>

    <button class="btn" @click="loadPage(page.pageIndex || 1)"><font-awesome-icon icon="rotate" /></button>
  </div>

  <div class="row mb-3">
    <div class="col-4">
      <router-link v-if="store.getters.isAdmin" :to="{ name: 'EditVorlage' }" class="btn btn-primary"><font-awesome-icon icon="plus" /> Erstellen</router-link>
    </div>

    <div class="col-4">
      <div v-if="viewSection == 'list'">
        <div class="input-group input-group-sm my-auto">
          <input v-model.trim="listSearchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." @search="searchVorlagen" />
          <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="searchVorlagen()">
            <font-awesome-icon icon="magnifying-glass" class="p-1" />
          </button>
        </div>
      </div>

      <div v-else-if="viewSection == 'grouped'">
        <div class="input-group input-group-sm my-auto">
          <input v-model.trim="searchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
          <span class="input-group-text">
            <font-awesome-icon icon="magnifying-glass" class="p-1" />
          </span>
        </div>
      </div>
    </div>

    <div class="col-4 text-end">
      <div class="btn-group" role="group" aria-label="View Section select">
        <button type="button" class="btn btn-outline-secondary" :class="{ active: viewSection === 'list' }" @click="setViewSection('list')">
          <font-awesome-icon icon="list" />
        </button>
        <button type="button" class="btn btn-outline-secondary" :class="{ active: viewSection === 'grouped' }" @click="setViewSection('grouped')">
          <font-awesome-icon icon="layer-group" />
        </button>
      </div>
    </div>
  </div>

  <div v-if="!loading && errorMsg != ''" class="alert alert-danger mt-5">
    {{ errorMsg }}
    <!-- Es ist ein Fehler beim Laden der Vorlagen aufgetreten. Bite probieren Sie es später erneut. -->
  </div>

  <section>
    <section v-if="viewSection == 'list'">
      <div v-if="page.items.length > 0" class="mt-2">
        <div class="row mx-0 mb-2 bg-white shadow-sm">
          <div class="col-4 py-2 table-col">
            <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>Vorlage</strong>

              <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'nameasc'" class="text-secondary table-sort-icon" />
              <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'namedesc'" class="text-secondary table-sort-icon" />

              <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                <li class="dropdown-item select-sort" @click="sortBy('nameasc')">
                  <div class="row">
                    <div class="col-2">
                      <font-awesome-icon icon="check" v-show="sortByValue == 'nameasc'" />
                    </div>
                    <div class="col">A - Z</div>
                  </div>
                </li>
                <li class="dropdown-item select-sort" @click="sortBy('namedesc')">
                  <div class="row">
                    <div class="col-2">
                      <font-awesome-icon icon="check" v-show="sortByValue == 'namedesc'" />
                    </div>
                    <div class="col">Z - A</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-4 py-2 table-col">
            <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>Überschrift</strong>

              <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'titelasc'" class="text-secondary table-sort-icon" />
              <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'titeldesc'" class="text-secondary table-sort-icon" />

              <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                <li class="dropdown-item select-sort" @click="sortBy('titelasc')">
                  <div class="row">
                    <div class="col-2">
                      <font-awesome-icon icon="check" v-show="sortByValue == 'titelasc'" />
                    </div>
                    <div class="col">A - Z</div>
                  </div>
                </li>
                <li class="dropdown-item select-sort" @click="sortBy('titeldesc')">
                  <div class="row">
                    <div class="col-2">
                      <font-awesome-icon icon="check" v-show="sortByValue == 'titeldesc'" />
                    </div>
                    <div class="col">Z - A</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-2 py-2 table-col">
            <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>Gruppe</strong>

              <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'gruppeasc'" class="text-secondary table-sort-icon" />
              <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'gruppedesc'" class="text-secondary table-sort-icon" />

              <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                <li class="dropdown-item select-sort" @click="sortBy('gruppeasc')">
                  <div class="row">
                    <div class="col-2">
                      <font-awesome-icon icon="check" v-show="sortByValue == 'gruppeasc'" />
                    </div>
                    <div class="col">A - Z</div>
                  </div>
                </li>
                <li class="dropdown-item select-sort" @click="sortBy('gruppedesc')">
                  <div class="row">
                    <div class="col-2">
                      <font-awesome-icon icon="check" v-show="sortByValue == 'gruppedesc'" />
                    </div>
                    <div class="col">Z - A</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-2 my-auto"><strong>Typ</strong></div>
        </div>

        <VorlageRow v-for="vorlage in page.items" :key="vorlage.id" :vorlage="vorlage" @reload-page="loadPage(page.pageIndex)" />
      </div>

      <div v-else class="alert alert-secondary">Es wurden keine Vorlagen gefunden.</div>

      <!-- Pagination -->
      <div class="row mx-0 mt-4">
        <div class="col-4 offset-4 my-auto">
          <nav v-if="page.totalPages > 1" aria-label="User pagination">
            <ul class="pagination">
              <li class="page-item" :class="{ disabled: !page.hasPrevious }">
                <button class="page-link" @click="goToPage(page.pageIndex - 1)" :disabled="!page.hasPrevious">
                  <font-awesome-icon icon="chevron-left" />
                </button>
              </li>

              <li v-for="pageNr in pagesToShow" :key="pageNr" class="page-item" :class="{ active: pageNr === page.pageIndex }">
                <button class="page-link" @click="goToPage(pageNr)">
                  {{ pageNr }}
                </button>
              </li>

              <li class="page-item" :class="{ disabled: !page.hasNext }">
                <button class="page-link" @click="goToPage(page.pageIndex + 1)" :disabled="!page.hasNext">
                  <font-awesome-icon icon="chevron-right" />
                </button>
              </li>
            </ul>
          </nav>
        </div>

        <div class="col-4 my-auto d-flex justify-content-end align-items-center">
          <label class="form-label mb-0 me-2">Einträge pro Seite:</label>
          <select class="form-select d-inline-block w-auto" v-model.number="localPageSize" @change="changePageSize">
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
      </div>
    </section>

    <section v-else-if="viewSection == 'grouped'">
      <div v-if="vorlagen.length > 0" class="mt-2">
        <div v-for="(value, key) in groupedVorlagen" :key="key" class="mb-4">
          <h4>{{ key }}</h4>

          <div class="row mx-0 mb-1">
            <div class="col-4 fw-bold px-2 my-auto">Vorlage</div>
            <div class="col-4 fw-bold px-2 my-auto">Überschrift</div>
            <div class="col-2 fw-bold px-2 my-auto">Gruppe</div>
            <div class="col-2 fw-bold px-2 my-auto">Typ</div>
          </div>

          <VorlageRow v-for="vorlage in value" :key="vorlage.id" :vorlage="vorlage" />
        </div>
      </div>
    </section>

    <div v-else-if="!loading && errorMsg == '' && vorlagen.length == 0" class="alert alert-info mt-5">Es wurden keine Vorlagen gefunden.</div>
  </section>

  <LoadingOverlay v-if="loading" text="... Vorlagen werden geladen ..." />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, ref, onMounted } from 'vue';
  import { useStore } from 'vuex';

  import { ActionTypes as VorlageActionTypes } from '@/store/modules/Vorlagen/actions';

  import VorlageRow from '@/components/Vorlagen/VorlageRow.vue';
  import LoadingOverlay from '@/components/LoadingOverlay.vue';

  import { GroupedVorlagenItems, VorlageItem } from '@/models/VorlageModels';
  import { PagedRequest, SortDirection } from '@/models/CommonModels';
  //#endregion

  const store = useStore();

  const loading = computed(() => store.getters.status.getVorlageLoading);
  const errorMsg = computed(() => store.getters.status.vorlageErrorMsg);

  //#region Paged
  const page = computed(() => store.getters.vorlagePage);

  const pagesToShow = computed(() => {
    const maxPages = 5;
    const pages: number[] = [];

    let start = Math.max(1, page.value.pageIndex - Math.floor(maxPages / 2));
    let end = Math.min(page.value.totalPages, start + maxPages - 1);

    // ggf. Anfang anpassen, wenn wir am Ende sind
    if (end - start + 1 < maxPages) {
      start = Math.max(1, end - maxPages + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  });

  async function goToPage(pageIdx: number) {
    if (pageIdx < 1 || pageIdx > page.value.totalPages || pageIdx === page.value.pageIndex) return;
    await loadPage(pageIdx);
  }

  async function loadPage(pageIdx: number, size?: number) {
    const pagedRequest = {
      page: pageIdx,
      pageSize: size ?? localPageSize.value,
      sortBy: sortByParam.value,
      sortDirection: sortByDirection.value,
      filter: listSearchString.value,
    } as PagedRequest;

    await store.dispatch(VorlageActionTypes.GetVorlagenPage, pagedRequest);
  }

  function changePageSize() {
    // bei Änderung der PageSize auf Seite 1 springen
    loadPage(1, localPageSize.value);
  }

  const sortByValue = ref('nameasc');
  const localPageSize = ref(page.value.pageSize);
  const sortByParam = ref('name');
  const sortByDirection = ref(SortDirection.asc);
  const listSearchString = ref('');

  async function searchVorlagen() {
    await loadPage(1);
  }

  async function sortBy(value: string) {
    sortByValue.value = value;

    sortByDirection.value = value.endsWith('asc') ? SortDirection.asc : SortDirection.desc;
    sortByParam.value = value.replace('asc', '').replace('desc', '');

    await loadPage(1);
  }

  const viewSection = ref('list');
  async function setViewSection(section: string) {
    viewSection.value = section;
    if (section == 'list') {
      searchString.value = '';
      sortByValue.value = 'nameasc';
      await loadPage(1, localPageSize.value);
    } else if (section == 'grouped') {
      sortByValue.value = 'gruppeasc';
      await loadVorlagen();
    }

    localStorage.setItem('vorlagenViewSection', section);
  }
  //#endregion

  const vorlagen = computed(() => store.getters.vorlagenItems);
  const sortedVorlagen = computed(() => {
    return vorlagen.value
      .filter((v: VorlageItem) => {
        return (
          v.name.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.titel.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.gruppe.trim().toLowerCase().includes(searchString.value.trim().toLowerCase())
        );
      })
      .sort((a: VorlageItem, b: VorlageItem) => {
        if (sortByValue.value == 'nameasc' || sortByValue.value == 'namedesc') {
          var nameComparison = a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase());
          if (sortByValue.value == 'namedesc') {
            nameComparison = -1 * nameComparison;
          }

          if (nameComparison == 0) {
            var titelComparison = a.titel.trim().toLowerCase().localeCompare(b.titel.trim().toLowerCase());
            return titelComparison;
          }

          return nameComparison;
        }

        if (sortByValue.value == 'titelasc' || sortByValue.value == 'titeldesc') {
          var titleComparison = a.titel.trim().toLowerCase().localeCompare(b.titel.trim().toLowerCase());
          if (sortByValue.value == 'titeldesc') {
            titleComparison = -1 * titleComparison;
          }

          if (titleComparison == 0) {
            var nameComparison = a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase());
            return nameComparison;
          }

          return titleComparison;
        }

        if (sortByValue.value == 'gruppeasc' || sortByValue.value == 'gruppedesc') {
          var groupComparison = a.gruppe.trim().toLowerCase().localeCompare(b.gruppe.trim().toLowerCase());
          if (sortByValue.value == 'gruppedesc') {
            groupComparison = -1 * groupComparison;
          }

          if (groupComparison == 0) {
            var nameComparison = a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase());
            return nameComparison;
          }

          return groupComparison;
        }

        return 0;
      });
  });

  const searchString = ref('');

  const groupedVorlagen = computed<GroupedVorlagenItems>(() => {
    const noGroup: VorlageItem[] = [];

    const data = sortedVorlagen.value.reduce((groups: GroupedVorlagenItems, vorlage: VorlageItem) => {
      if (!vorlage.gruppe) {
        noGroup.push(vorlage);
      } else {
        const groupsList = vorlage.gruppe.split(';');

        for (let group of groupsList) {
          group = group.trim();

          if (group === '') {
            continue;
          }

          const existingGroup = groups[group];

          if (existingGroup) {
            existingGroup.push(vorlage);
          } else {
            groups[group] = [vorlage];
          }
        }
      }
      return groups;
    }, {});

    // Sort keys alphabetically
    const sortedData: GroupedVorlagenItems = {};
    Object.keys(data)
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
      .forEach((key) => {
        sortedData[key] = data[key];
      });

    if (noGroup.length > 0) {
      sortedData['Keine Gruppe'] = noGroup;
    }

    return sortedData;
  });

  async function loadVorlagen() {
    await store.dispatch(VorlageActionTypes.GetVorlagenLight, undefined);
  }

  onMounted(async () => {
    viewSection.value = localStorage.getItem('vorlagenViewSection') || 'list';

    if (viewSection.value == 'list') {
      await loadPage(1);
    } else {
      await loadVorlagen();
    }
  });
</script>

<style scoped>
  .table-col:hover {
    background: rgb(216, 217, 222);
    cursor: pointer;
  }

  .table-sort-icon {
    font-size: 0.7em;
  }

  .select-sort:hover {
    cursor: pointer;
  }
</style>
